import { TimePeriodId, TimePeriodIdType } from '@/models/time-period';
import { Tab } from '@starsoft/common/src/components/Tabs/Tab/props';

export enum BiggestWinFilterOptions {
  '1Day' = '1day',
  '3Days' = '3Days',
  '7Days' = '7Days',
}

export type BiggestWinFilterOptionsProps = Array<Tab<BiggestWinFilterOptions>>;

export interface CarouselsBiggestWinsFilterProps {
  options: BiggestWinFilterOptionsProps;
  currentOption: BiggestWinFilterOptions;
  onOptionClick: (tab: BiggestWinFilterOptions) => void;
}

export namespace BigestWinFilter {
  export function getTimePeriodByOption(
    option: BiggestWinFilterOptions,
  ): TimePeriodIdType {
    switch (option) {
      case BiggestWinFilterOptions['1Day']:
        return TimePeriodId.Today;
      case BiggestWinFilterOptions['3Days']:
        return TimePeriodId.ThreeDays;
      case BiggestWinFilterOptions['7Days']:
        return TimePeriodId.OneWeek;
    }
  }
}
